import React, { useEffect } from 'react';
import get from 'lodash/get';
import {
  useParams,
  Link,
} from 'react-router-dom';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';

import { env } from '../../../config';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { resolveTo, getLang } from '~/commons/helpers';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormSchool from '../../forms/FormSchool.jsx';
import ListStudents from '../../lists/ListStudents.jsx';
import ListAdmins from '../../lists/ListAdmins.jsx';

const PageSchool = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({
        url: `/api/core/schools/${_id}`,
      });
    }
  }, [_id]);

  const breadcrumb = env.user.roles.includes('admin')
    ? [{ to: '../', children: 'Schools' }]
    : [];

  return _id === 'new' ? (
    <div>
      <Header breadcrumb={breadcrumb}>Create New</Header>
      <FormSchool />
    </div>
  ) : (
    <PageHttp res={res}>
      {(doc) => {
        const { t, i18n: { language } } = useTranslation();
        const lang = language === 'en' ? 'en' : 'zhhk';
        const info = [
          { label: 'Name (Chinese)', v: get(doc, 'title.zhhk') },
          { label: 'Name (English)', v: get(doc, 'title.en') },
          {
            label: 'District',
            v: get(env, `districts.${doc.district}.${lang}`),
          },
          {
            label: 'Stage',
            v: {
              p: { en: 'Primary', zhhk: '小學' },
              s: { en: 'Secondary', zhhk: '中學' },
            }[doc.stage][lang],
          },
        ].filter((({ v }) => v));

        return (
          <>
            <Header breadcrumb={breadcrumb}>
              {getLang(doc.title, lang)}
            </Header>
            {/* school info */}
            {env.user.roles.includes('admin') && (
              <div className="card p-4">
                <div className="row align-items-center">
                  <div className="col">
                    {info.map((a, i) => (
                      <div className="row" key={i}>
                        <div className="col-4">
                          <strong>{t(a.label)}</strong>
                        </div>
                        <div className="col">
                          {a.v}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="col-auto">
                    <Link
                      to={resolveTo('edit')}
                      className="btn btn-link"
                    >
                      <FA icon={faPencilAlt} size="lg" />
                    </Link>
                  </div>
                </div>
              </div>
            )}

            {env.user.roles.includes('admin') ? (
            // {/* students and admins list */}
              <div className="mt-5">
                <Tabs>
                  <Tab eventKey="students" title={t('Students')}>
                    <div className="pt-4">
                      <ListStudents
                        school={doc._id}
                        basePath="students/"
                      />
                    </div>
                  </Tab>
                  <Tab eventKey="admins" title={t('School Admins')}>
                    <div className="pt-4">
                      <ListAdmins
                        school={doc._id}
                        basePath="admins/"
                      />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            ) : (
              // schoolAdmin only see admins
              <div className="pt-4">
                <ListAdmins
                  school={doc._id}
                  basePath="admins/"
                />
              </div>
            )}
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchool;
